const UnderlinedText = () => (
  <>
    <path
      fill="currentColor"
      d="M7.192 18.923a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356a.49.49 0 0 1 .356-.143h9.616q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.49.49 0 0 1-.356.143zM12 16.173q-2.14 0-3.358-1.257-1.217-1.259-1.217-3.416V6.064q0-.233.171-.398a.56.56 0 0 1 .403-.166q.232 0 .395.166.165.165.164.397v5.472q0 1.63.911 2.582.912.952 2.531.952t2.53-.952.912-2.582V6.064q0-.233.172-.398a.56.56 0 0 1 .402-.166q.233 0 .396.166.163.165.163.397V11.5q0 2.158-1.217 3.415T12 16.174"
    />
  </>
)
export default UnderlinedText
